import React, { useState, useEffect ,useRef} from 'react';
// import { Link } from 'react-router-dom';
import './writehere.css';
import Navbar from '../Navbar';
import StartWritingComp from './StartWritingComp';
import StartWritingPaid from './StartWritingPaid';
import Web3 from 'web3';
import './StartWrtingComp.css';
import WriteUpload from './WriteUpload';

import { useNavigate} from 'react-router-dom'


export default function WriteHere() {
    
    const [walletAddress, setWalletAddress] = useState('');
    const [walletConnected, setWalletConnected] = useState(false);
    const [startWriting, showStartWritingComp] = useState(false);
    const [writeupload, showwriteupload] = useState(false);
    const [startWritingpaid, showStartWritingPaid] = useState(false);
    const [showModal, setShowModal] = useState(false);
    // const [accountsChangedCallback, setAccountsChangedCallback] = useState(null);
    // const location = useLocation();
    const navigate = useNavigate();
    // const [approve,setapprove]=useState(false);
const viewdao=()=>{
    navigate('/files');
}

useEffect(()=>{
    if(localStorage.getItem('address')){
        setWalletConnected(true);
    }

},[walletConnected])
const h1Ref = useRef(null);

useEffect(() => {
  const h1Element = h1Ref.current;
  h1Element.classList.add('visible');
}, []);
    useEffect(() => {
       
        // Perform any necessary checks or actions to determine if the wallet is connected
        // const isWalletConnected = false;
        // setWalletConnected(isWalletConnected);
        // setWalletConnected(location.state?.walletConnected);
       
        if (window.ethereum) {
            // Check if MetaMask is installed
            // You can display a message or take appropriate action here
            console.log('MetaMask is installed!');

            const handleWalletDisconnect = () => {
                setWalletAddress('');
                setWalletConnected(false);
            };

            window.ethereum.on('accountsChanged', handleWalletDisconnect);
            // setAccountsChangedCallback(() => handleWalletDisconnect);
        }
        // if (window.cardano) {
        //     // Check if Nami Wallet is installed
        //     // You can display a message or take appropriate action here
        //     console.log('Nami Wallet is installed!');

        //     const handleWalletDisconnect = () => {
        //         setWalletAddress('');
        //         setWalletConnected(false);
        //     };

        //     // Replace 'disconnect' with the appropriate event name for Nami Wallet
        //     window.cardano.disconnect(handleWalletDisconnect);
        // }

        return () => {
            // Clean up the event listeners when the component is unmounted
            // if (window.ethereum) {
            //     const callback = accountsChangedCallback;
            //     if (callback) {
            //         window.ethereum.off('accountsChanged', callback);
            //     }
            // }
            // Clean up the event listener when the component is unmounted
            // if (window.cardano) {
            //     // Replace 'disconnect' with the appropriate event name for Nami Wallet
            //     window.cardano.disconnect(null);
            // }
        };
    }, []);


    const handleWalletDisconnect = () => {
        setWalletAddress('');
        setWalletConnected(false);
    };


    const sendData = async (walletData) => {
        try {
            const url = '/WriteHere';

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: walletData
            });

            const responseData = await response.json();
            console.log(responseData);
        } catch (error) {
            console.error('Error sending data:', error);
        }
    };
    // JavaScript or React code
    const writeherecard = document.querySelector('.writeherecard');
    if (writeherecard) {
      writeherecard.classList.add('show-card');
    }
    

    const connectWallet = async (walletType) => {
        try {

            let provider;
            if (walletType === 'metamask') {
                // Check if MetaMask is available
                if (!window.ethereum) {
                    console.error('MetaMask is not available');
                    return;
                }
                // Request access to MetaMask
                await window.ethereum.request({ method: 'eth_requestAccounts' });
                provider = window.ethereum;
                const web3 = new Web3(provider);

                // Get the connected wallet address
                const accounts = await web3.eth.getAccounts();
                setWalletAddress(accounts[0]);
                localStorage.setItem('selectedwallet','metamask');
                // navigate('/showAddress');
                setWalletConnected(true);
                localStorage.setItem('address',accounts[0]);

            } else if (walletType === 'nami') {
                // // Connect to Nami Wallet
                // if (!window.cardano) {
                //     console.error('Nami Wallet is not available');
                //     return;
                // }
                // await window.cardano.enable();
                // provider = window.cardano;
                if (window.cardano && window.cardano.nami && window.cardano.nami.enable) {
                    try {
                        const namiAPI = await window.cardano.nami.enable();
                        const addresses = await namiAPI.getUsedAddresses();
                        const address = addresses[0]; // Assuming the first address is the desired one
                        setWalletAddress(address);
                        localStorage.setItem('address',address);
                        // navigate('/showAddress');
                        localStorage.setItem('selectedwallet','nami');
                        setWalletConnected(true);
                    } catch (error) {
                        console.error('Failed to enable Nami wallet:', error);
                    }
                } else {
                    console.error('Nami wallet not found.');
                }
            } else {
                console.error('Invalid wallet type');
                return;
            }


            const walletData = {
                address: walletAddress
            };
            sendData(walletData);
            setShowModal(false)

        } catch (error) {
            console.error('Failed to connect to wallet:', error);
        }
        
    };

    return (
        <>
            <Navbar showMenu={false} walletConnected={walletConnected} onDisconnect={handleWalletDisconnect} />
            <section id="writehere" style={{ position: 'relative' }}>
                <div className="container page-content d-flex justify-content-center align-items-center flex-column mt-5">
                <h1 ref={h1Ref}>
          <span>Write</span>
          <span className="space"> </span>
          <span>here</span>
          <span className="space"> </span>
          <span> now,</span>
          <span className="space"> </span>
          <span> we</span>
          <span className="space"> </span>
          <span> will</span>
          <span className="space"> </span>
          <span>share</span>
          <span className="space"> </span>
          <span> it</span>
          <span className="space"> </span>
          <span>later</span>
          {/* <span>e</span>
          <span className="space"> </span>
          <span>n</span>
          <span>o</span>
          <span>w</span>
          <span>,</span>
          <span className="space"> </span>
          <span>w</span>
          <span>e</span>
          <span className="space"> </span>
          <span>w</span>
          <span>i</span>
          <span>l</span>
          <span>l</span>
          <span className="space"> </span>
          <span>s</span>
          <span>h</span>
          <span>a</span>
          <span>r</span>
          <span>e</span>
          <span className="space"> </span>
          <span>i</span>
          <span>t</span>
          <span className="space"> </span>
          <span>l</span>
          <span>a</span>
          <span>t</span>
          <span>e</span>
          <span>r</span> */}
        </h1>

                    {!walletConnected && !startWriting ? (
                        <div className="writeherecard">
                            <h2>Connect your wallet to start</h2>
                            {walletAddress ? (
                                <p>Connected wallet address: {walletAddress}</p>
                            ) : (
                                // <button onClick={connectWallet}>Connect MetaMask</button>
                                <>
                                    {/* <button >Connect Wallet</button> */}

                                    <button
                                        type="button"
                                        className="btn btn-outline-primary rounded-pill  walletBtn btn-lg px-5 py-2"
                                        data-toggle="modal"
                                        id='connect'
                                        // data-bs-toggle="modal" data-bs-target="#selectWalletModal"
                                        // onClick={() => setWalletConnected(true)}
                                        onClick={() => setShowModal(true)}
                                    >
                                        Connect wallet
                                    </button>
                                </>
                            )}
                            {/* {showModal && ( */}
                            <div className={`modal fade${showModal ? ' show' : ''}`} id="selectWalletModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ display: showModal ? 'block' : 'none', backgroundColor: 'rgb(15, 28, 112, .6) ', opacity: 1 }}>
                                <div className="modal-dialog modal-dialog-centered mb-0" >
                                    <div className="modal-content mb-0" style={{ backgroundColor: '(15, 28, 112, .6)' }}>
                                        <div className="modal-header mb-0">
                                            <button type="button" className="btn-close mb-0" data-bs-dismiss="modal" aria-label="Close" onClick={() => setShowModal(false)}></button>
                                        </div>
                                        <div className="modal-body mb-0">
                                            <div className="container">
                                                <h4 className='text-dark mb-0'>Connect to:</h4>
                                                <div className="radio-tile-group">
                                                    <div className="input-container">
                                                        <input id="walk" className="radio-button" type="radio" name="radio" onClick={() => {
                                                            connectWallet('nami');

                                                        }
                                                        } />
                                                        <div className="radio-tile">
                                                            <div className="icon walk-icon mb-0 d-flex align-items-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 486.17 499.86" className=''>
                                                                    <defs>
                                                                        <style>
                                                                            {`.cls-1{fill:#349ea3;}`}
                                                                        </style>
                                                                    </defs>
                                                                    <g id="Layer_2" data-name="Layer 2">
                                                                        <g id="Layer_1-2" data-name="Layer 1">
                                                                            <path
                                                                                id="path16"
                                                                                className="cls-1"
                                                                                d="M73.87,52.15,62.11,40.07A23.93,23.93,0,0,1,41.9,61.87L54,73.09,486.17,476ZM102.4,168.93V409.47a23.76,23.76,0,0,1,32.13-2.14V245.94L395,499.86h44.87Zm303.36-55.58a23.84,23.84,0,0,1-16.64-6.68v162.8L133.46,15.57H84L421.28,345.79V107.6A23.72,23.72,0,0,1,405.76,113.35Z"
                                                                            />
                                                                            <path
                                                                                id="path18"
                                                                                className="cls-1"
                                                                                d="M38.27,0A38.25,38.25,0,1,0,76.49,38.27v0A38.28,38.28,0,0,0,38.27,0ZM41.9,61.8a22,22,0,0,1-3.63.28A23.94,23.94,0,1,1,62.18,38.13V40A23.94,23.94,0,0,1,41.9,61.8Z"
                                                                            />
                                                                            <path
                                                                                id="path20"
                                                                                className="cls-1"
                                                                                d="M405.76,51.2a38.24,38.24,0,0,0,0,76.46,37.57,37.57,0,0,0,15.52-3.3A38.22,38.22,0,0,0,405.76,51.2Zm15.52,56.4a23.91,23.91,0,1,1,8.39-18.18A23.91,23.91,0,0,1,421.28,107.6Z"
                                                                            />
                                                                            <path
                                                                                id="path22"
                                                                                className="cls-1"
                                                                                d="M134.58,390.81A38.25,38.25,0,1,0,157.92,426a38.24,38.24,0,0,0-23.34-35.22Zm-15,59.13A23.91,23.91,0,1,1,143.54,426a23.9,23.9,0,0,1-23.94,23.91Z"
                                                                            />
                                                                        </g>
                                                                    </g>
                                                                </svg>
                                                            </div>
                                                            <label htmlFor="walk" className="radio-tile-label mx-3 mb-0">Nami wallet</label>
                                                        </div>
                                                    </div>

                                                    <div className="input-container">
                                                        <input id="bike" className="radio-button mb-0" type="radio" name="radio" onClick={() => { connectWallet('metamask'); }} />
                                                        <div className="radio-tile">
                                                            <div className="icon bike-icon mb-0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="212" height="189" viewBox="0 0 212 189" id="metamask"><g fill="none" fillRule="evenodd"><polygon fill="#CDBDB2" points="60.75 173.25 88.313 180.563 88.313 171 90.563 168.75 106.313 168.75 106.313 180 106.313 187.875 89.438 187.875 68.625 178.875"></polygon><polygon fill="#CDBDB2" points="105.75 173.25 132.75 180.563 132.75 171 135 168.75 150.75 168.75 150.75 180 150.75 187.875 133.875 187.875 113.063 178.875" transform="matrix(-1 0 0 1 256.5 0)"></polygon><polygon fill="#393939" points="90.563 152.438 88.313 171 91.125 168.75 120.375 168.75 123.75 171 121.5 152.438 117 149.625 94.5 150.188"></polygon><polygon fill="#F89C35" points="75.375 27 88.875 58.5 95.063 150.188 117 150.188 123.75 58.5 136.125 27"></polygon><polygon fill="#F89D35" points="16.313 96.188 .563 141.75 39.938 139.5 65.25 139.5 65.25 119.813 64.125 79.313 58.5 83.813"></polygon><polygon fill="#D87C30" points="46.125 101.25 92.25 102.375 87.188 126 65.25 120.375"></polygon><polygon fill="#EA8D3A" points="46.125 101.813 65.25 119.813 65.25 137.813"></polygon><polygon fill="#F89D35" points="65.25 120.375 87.75 126 95.063 150.188 90 153 65.25 138.375"></polygon><polygon fill="#EB8F35" points="65.25 138.375 60.75 173.25 90.563 152.438"></polygon><polygon fill="#EA8E3A" points="92.25 102.375 95.063 150.188 86.625 125.719"></polygon><polygon fill="#D87C30" points="39.375 138.938 65.25 138.375 60.75 173.25"></polygon><polygon fill="#EB8F35" points="12.938 188.438 60.75 173.25 39.375 138.938 .563 141.75"></polygon><polygon fill="#E8821E" points="88.875 58.5 64.688 78.75 46.125 101.25 92.25 102.938"></polygon><polygon fill="#DFCEC3" points="60.75 173.25 90.563 152.438 88.313 170.438 88.313 180.563 68.063 176.625"></polygon><polygon fill="#DFCEC3" points="121.5 173.25 150.75 152.438 148.5 170.438 148.5 180.563 128.25 176.625" transform="matrix(-1 0 0 1 272.25 0)"></polygon><polygon fill="#393939" points="70.313 112.5 64.125 125.438 86.063 119.813" transform="matrix(-1 0 0 1 150.188 0)"></polygon><polygon fill="#E88F35" points="12.375 .563 88.875 58.5 75.938 27"></polygon><path fill="#8E5A30" d="M12.3750002,0.562500008 L2.25000003,31.5000005 L7.87500012,65.250001 L3.93750006,67.500001 L9.56250014,72.5625 L5.06250008,76.5000011 L11.25,82.1250012 L7.31250011,85.5000013 L16.3125002,96.7500014 L58.5000009,83.8125012 C79.1250012,67.3125004 89.2500013,58.8750003 88.8750013,58.5000009 C88.5000013,58.1250009 63.0000009,38.8125006 12.3750002,0.562500008 Z"></path><g transform="matrix(-1 0 0 1 211.5 0)"><polygon fill="#F89D35" points="16.313 96.188 .563 141.75 39.938 139.5 65.25 139.5 65.25 119.813 64.125 79.313 58.5 83.813"></polygon><polygon fill="#D87C30" points="46.125 101.25 92.25 102.375 87.188 126 65.25 120.375"></polygon><polygon fill="#EA8D3A" points="46.125 101.813 65.25 119.813 65.25 137.813"></polygon><polygon fill="#F89D35" points="65.25 120.375 87.75 126 95.063 150.188 90 153 65.25 138.375"></polygon><polygon fill="#EB8F35" points="65.25 138.375 60.75 173.25 90 153"></polygon><polygon fill="#EA8E3A" points="92.25 102.375 95.063 150.188 86.625 125.719"></polygon><polygon fill="#D87C30" points="39.375 138.938 65.25 138.375 60.75 173.25"></polygon><polygon fill="#EB8F35" points="12.938 188.438 60.75 173.25 39.375 138.938 .563 141.75"></polygon><polygon fill="#E8821E" points="88.875 58.5 64.688 78.75 46.125 101.25 92.25 102.938"></polygon><polygon fill="#393939" points="70.313 112.5 64.125 125.438 86.063 119.813" transform="matrix(-1 0 0 1 150.188 0)"></polygon><polygon fill="#E88F35" points="12.375 .563 88.875 58.5 75.938 27"></polygon><path fill="#8E5A30" d="M12.3750002,0.562500008 L2.25000003,31.5000005 L7.87500012,65.250001 L3.93750006,67.500001 L9.56250014,72.5625 L5.06250008,76.5000011 L11.25,82.1250012 L7.31250011,85.5000013 L16.3125002,96.7500014 L58.5000009,83.8125012 C79.1250012,67.3125004 89.2500013,58.8750003 88.8750013,58.5000009 C88.5000013,58.1250009 63.0000009,38.8125006 12.3750002,0.562500008 Z"></path></g></g></svg>
                                                            </div>
                                                            <label htmlFor="bike" className="radio-tile-label mb-0">Metamask Wallet</label>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* )} */}
                        </div>
                    ) : !startWriting && !startWritingpaid && !writeupload ? (
                        <div className="writeherecard spl" >

                            <button
                                type="button"
                                className="btn btn-primary btn-lg walletBtn w-100 text-center"
                                data-toggle="modal"
                                data-target="#profile-modal"
                                data-aos="fade-up"
                                onClick={
                                    () => {
                                        // showStartWritingPaid(false);
                                        console.log(startWritingpaid);
                                        showStartWritingComp(true)}
                                }
                            >
                                Start writing here for Free
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary btn-lg w-100 walletBtn"
                                data-aos="fade-left"
                                onClick={
                                    () =>{ showStartWritingPaid(true);
                                        console.log(startWritingpaid);
                                        //  showStartWritingComp(true);
                                    }
                                }
                            >
                                Start writing here
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary btn-lg w-100 walletBtn"
                                data-aos="fade-right"
                                onClick={
                                    ()=>{showwriteupload(true);
                                        // showStartWritingPaid(true);
                                    }
                                }
                            >
                                Upload / Write Document
                            </button>
                            
                            <button
                                type="button"
                                className="btn btn-primary btn-lg w-100 walletBtn"
                                data-aos="fade-left"
                                onClick={()=>viewdao()}
                            >
                                View your DAO
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary btn-lg w-100 mb-0 walletBtn"
                                data-aos="fade-right"
                            >
                                Trustee and Successor
                            </button>
                        </div>
                    )
                        : (startWriting?(
                           
                            <StartWritingComp />

                        ): (
                            startWritingpaid ?(
                                <StartWritingPaid />
                            ): writeupload &&(
                                <WriteUpload />
                            )
                        )
                       
                        )
                       
                    }
                </div>
            </section>
        </>
    );
}
